import { Dispatch, SetStateAction } from "react";

export type GeneratorRandomPasswordInput = {
    uppercase: boolean;
    lowercase: boolean;
    special: boolean;
    numbers: boolean;
    range: number;
    capitalizeFirst: boolean
};

type GeneratorRandomPasswordOptionsProps = {
    input: GeneratorRandomPasswordInput;
    setInput: Dispatch<SetStateAction<GeneratorRandomPasswordInput>>;
};

export function GeneratorRandomPasswordOptions({ input, setInput }: GeneratorRandomPasswordOptionsProps) {

    const handleCheckboxChange = (key: keyof GeneratorRandomPasswordInput) =>
        (event: React.ChangeEvent<HTMLInputElement>) => {
            const isChecked = event.target.checked;
            setInput(prev => ({
                ...prev,
                [key]: isChecked,
                ...(key === "capitalizeFirst" && isChecked ? { uppercase: false } : {}),
                ...(key === "uppercase" && isChecked ? { capitalizeFirst: false } : {})
            }));
        };


    const options = [
        { label: "Include Special Characters", key: "special", description: "(#$&)" },
        { label: "Include Lowercase Letters", key: "lowercase", description: "(a-z)" },
        { label: "Include Uppercase Letters", key: "uppercase", description: "(A-Z)" },
        { label: "Include Numbers", key: "numbers", description: "(0-9)" },
        { label: "Capitalize only the first letter, ensuring the rest remain lowercase.", key: "capitalizeFirst", description: "(Abcd)" }
    ];



    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "20px" }}>
            {options.map(({ label, key, description }) => (
                <label key={key} htmlFor={key} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <input
                        aria-label={label}
                        id={key}
                        type="checkbox"
                        onChange={handleCheckboxChange(key as keyof GeneratorRandomPasswordInput)}
                        checked={input[key as keyof GeneratorRandomPasswordInput] as boolean}
                    />
                    {label} - <b>{description}</b>
                </label>
            ))}
        </div>
    );
}
